import { DesignElementSnapshotReason } from "@supernova-studio/model";
import { DTODocumentationPageV2 } from "../elements/documentation/page-v2";
import { z } from "zod";
export const DTODocumentationPageSnapshot = z.object({
    id: z.string(),
    designSystemVersionId: z.string(),
    createdAt: z.string(),
    updatedAt: z.string(),
    documentationPage: DTODocumentationPageV2,
    pageContentHash: z.string(),
    reason: DesignElementSnapshotReason,
});
